import { useNavigation } from './useNavigation'

export default useNavigation
